window.IndexPage = {
    
    setupCarousel: function () {
        
        $('.own-owl-carousel').owlCarousel({
            items:3,
            slideBy: 3,
            autoWidth: false,
            dots : false,
            nav:true,
            responsiveClass:true,
            navText: ["<img src='/v1/img/seta-esquerda.png'>","<img src='/v1/img/seta-direita.png'>"],
            responsive: {
                0:{
                    items:1,
                    slideBy: 1,
                    nav: false
                },
                600:{
                    items:2,
                    slideBy: 2,
                    nav: false
                },
                1000:{
                    items:3,
                    slideBy: 3
                }
            }
        });
        
        $('.own-new-owl-carousel').owlCarousel({
            autoWidth: true,
            slideBy: 1,
            items: 3,
            loop: true,
            dots: false,
            nav: false,
            responsiveClass: true,
            responsive: {
                0: {
                    items: 1,
                    slideBy: 1,
                    nav: false
                },
                400: {
                    items: 1,
                    slideBy: 1,
                    nav: false
                },
                1000: {
                    items: 3,
                    slideBy: 3
                }
            }
        });
        
        // Custom Navigation Events
        $(".customNavigationOwl > .next").click(function () {
            var owl = $('.own-new-owl-carousel');
            owl.trigger('next.owl.carousel');
        })
        $(".customNavigationOwl > .prev").click(function () {
            var owl = $('.own-new-owl-carousel');
            owl.trigger('prev.owl.carousel');
        })
        
        $('.owl-full').owlCarousel({
            items:1,
            slideBy: 1,
            autoWidth: false,
            dots : true,
            responsiveClass:true,
            responsive: {
                0:{
                    items:1,
                    slideBy: 1,
                    nav: false
                },
                600:{
                    items:1,
                    slideBy: 1,
                    nav: false
                },
                1000:{
                    items:1,
                    slideBy: 1
                }
            },
            autoplay: true,
            autoplayTimeout: 4500,
            autoplaySpeed: 4500,
            autoplayHoverPause: true,
            loop:true
        });
        
        $('.owl-recorrente').owlCarousel({
            items:3,
            slideBy: 3,
            autoWidth: false,
            dots : false,
            nav:true,
            responsiveClass:true,
            navText: ["<img src='/v1/img/seta-esquerda-azul.png'>","<img src='/v1/img/seta-direita-azul.png'>"],
            responsive: {
                0:{
                    items:1,
                    slideBy: 1,
                    nav: false
                },
                600:{
                    items:2,
                    slideBy: 2,
                    nav: false
                },
                1000:{
                    items:3,
                    slideBy: 3
                }
            }
        })
        
        $('.owl-parceirias').owlCarousel({
            items: 3,
            slideBy: 1  ,
            nav: true,
            dots: false,
            navText: ["<img src='/v1/img/seta-esquerda-cinza.png'>", "<img src='/v1/img/seta-direita-cinza.png'>"],
            autoWidth: true,
            responsive: {
                0: {
                    items: 1,
                    slideBy: 1,
                    nav: false
                },
                600: {
                    items: 1,
                    slideBy: 1,
                    nav: false
                },
                1000: {
                    items: 1,
                    slideBy: 1
                }
            }
        })
        
        $('.owl-canal').owlCarousel({
            items: 1,
            nav:true,
            dots : false,
            navText: ["<img src='/v1/img/seta-esquerda-cinza.png'>","<img src='/v1/img/seta-direita-cinza.png'>"],
            autoWidth:false,
            responsive: {
                0:{
                    items:1,
                    slideBy: 1,
                    nav: false
                },
                600:{
                    items:1,
                    slideBy: 1,
                    nav: false
                },
                1000:{
                    items:1,
                    slideBy: 1
                }
            }
        })
    },
    
    setupStackedSlider: function() {
        function detect_active() {
            // get active
            var get_active = $("#dp-slider .dp_item:first-child").data("class");
            $("#dp-dots li").removeClass("active");
            $("#dp-dots li[data-class=" + get_active + "]").addClass("active");
        }
        $("#dp-next").click(function () {
            var total = $(".dp_item").length;
            $("#dp-slider .dp_item:first-child").hide().appendTo("#dp-slider").fadeIn();
            $.each($('.dp_item'), function (index, dp_item) {
                $(dp_item).attr('data-position', index + 1);
            });
            detect_active();
            
        });
        
        $("#dp-prev").click(function () {
            var total = $(".dp_item").length;
            $("#dp-slider .dp_item:last-child").hide().prependTo("#dp-slider").fadeIn();
            $.each($('.dp_item'), function (index, dp_item) {
                $(dp_item).attr('data-position', index + 1);
            });
            
            detect_active();
        });
        
        $("#dp-dots li").click(function () {
            $("#dp-dots li").removeClass("active");
            $(this).addClass("active");
            var get_slide = $(this).attr('data-class');
            console.log(get_slide);
            $("#dp-slider .dp_item[data-class=" + get_slide + "]").hide().prependTo("#dp-slider").fadeIn();
            $.each($('.dp_item'), function (index, dp_item) {
                $(dp_item).attr('data-position', index + 1);
            });
        });
        
        
        $("body").on("click", "#dp-slider .dp_item:not(:first-child)", function () {
            var get_slide = $(this).attr('data-class');
            console.log(get_slide);
            $("#dp-slider .dp_item[data-class=" + get_slide + "]").hide().prependTo("#dp-slider").fadeIn();
            $.each($('.dp_item'), function (index, dp_item) {
                $(dp_item).attr('data-position', index + 1);
            });
            
            detect_active();
        });    
    },
    
    dropDownMenu: (element,e) => {
        element.next('ul').toggle();
        e.stopPropagation();
        e.preventDefault();
    }
    
};

let dropDownElement = $('.dropdown-submenu a.test');
let liElement = $('.dropdown-submenu ul li');

liElement.mouseout(function(e) {
    IndexPage.dropDownMenu(dropDownElement,e);
});

dropDownElement.on("click", function(e){
    IndexPage.dropDownMenu(dropDownElement,e);
});


IndexPage.setupCarousel();
IndexPage.setupStackedSlider();

App.bindEvent('ChangeImageOverMobile', 'click', function(ev) {
    var isExpanded = $(this).attr('aria-expanded');
    if(isExpanded == 'true') {
        $('.navbar-brand > img').attr("src","/v2/dist/img/benfeitoria/logo/pink.png");
    } else {
        $('.navbar-brand > img').attr("src","/v2/dist/img/benfeitoria/logo/white.png");
    }
});